var portfolioBreakdown = {
	table: {
		caption: "Portfolio Breakdown",
		name: {
			assetClass: "Asset class",
			currency: "Currency",
			sector: "Sector"
		}
	},
	chart: {
		counting: {
			assetClass: "Classes d'Actifs",
			currency: "Devises",
			sector: "Secteurs"
		},
		topPositions: {
			assetClass: "Top asset classes",
			currency: "Top currencies",
			sector: "Top sectors"
		}
	},
	assetClasses: {
		bond: "Obligation",
		commodity: "Commodité",
		currency: "Devise",
		debt: "Dette",
		etf: "ETF",
		fund: "Fonds",
		generic: "Générique",
		index: "Indice",
		stock: "Action",
		interestRate: "Taux d'intérêt",
		structuredProduct: "Produit structuré",
		investmentProduct: "Produit d'investissement",
		leveragedProduct: "Produit à effet de levier",
		option: "Option",
		future: "Futures"
	}
};
var fr = {
	portfolioBreakdown: portfolioBreakdown
};

export { fr as default, portfolioBreakdown };
